import { render } from "./AlliedList.vue?vue&type=template&id=0a5b06d6"
import script from "./AlliedList.vue?vue&type=script&lang=js"
export * from "./AlliedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__